<div class="header">
    <div class="user-info">
        <div class="avatar">{{ userProfile?.name?.[0] }}{{ userProfile?.surname?.[0] }}</div>
        <!-- Iniciales del usuario -->
        <span>{{ userProfile?.name }} {{ userProfile?.surname }}</span> <!-- Nombre del usuario -->
    </div>
    <mat-icon class="close-icon" (click)="closeDialog()">close</mat-icon>
</div>
<mat-dialog-content>
    <mat-nav-list>

        <mat-list-item routerLink="/settings/user-profile" (click)="closeDialog()">
            <span><mat-icon mat-list-icon>account_circle</mat-icon>{{
                'NAVIGATION.DIALOGS.USER-OPTIONS-MENU.MY_PROFILE'
                | translate }}</span>
        </mat-list-item>
        <mat-list-item routerLink="/settings/organization-profile" (click)="closeDialog()">
            <span><mat-icon mat-list-icon>domain</mat-icon>{{ 'NAVIGATION.DIALOGS.USER-OPTIONS-MENU.ORGANIZATION' |
                translate }}</span>
        </mat-list-item>
        <!-- *ngIf="existInModulesAndCanAccess('USERS')" -->
        <mat-list-item *ngIf="existInModulesAndCanAccess('USERS')" routerLink="/settings/users" (click)="closeDialog()">
            <span><mat-icon mat-list-icon>groups</mat-icon>{{ 'NAVIGATION.DIALOGS.USER-OPTIONS-MENU.USERS' |
                translate }}</span>
        </mat-list-item>
        <mat-list-item *ngIf="existInModulesAndCanAccess('PLANS')" routerLink="/settings/plans" (click)="closeDialog()">
            <span><mat-icon mat-list-icon>extension</mat-icon>Plans</span>
        </mat-list-item>
        <mat-list-item routerLink="/pills" (click)="closeDialog()">
            <span><mat-icon mat-list-icon>subject</mat-icon>{{
                'NAVIGATION.DIALOGS.USER-OPTIONS-MENU.ALIMENTIUM_PILLS' |
                translate }}</span>
        </mat-list-item>
        <mat-list-item *ngIf="existInModulesAndCanAccess('ADMINISTRATION')" routerLink="/administration"
            (click)="closeDialog()">
            <span><mat-icon mat-list-icon>admin_panel_settings</mat-icon>{{
                'NAVIGATION.DIALOGS.USER-OPTIONS-MENU.ADMINISTRATION' | translate }}</span>
        </mat-list-item>
        <mat-list-item (click)="onOptionClick('AboutUs')">
            <span><mat-icon mat-list-icon>contact_support</mat-icon>{{
                'NAVIGATION.DIALOGS.USER-OPTIONS-MENU.ABOUT_US' |
                translate }}<mat-icon mat-list-icon>open_in_new</mat-icon>
            </span>
        </mat-list-item>

    </mat-nav-list>
</mat-dialog-content>